'use client'

import { InstructionSize } from '@/app/[locale]/product/[slug]/_components/product-info-sizes/instructions-size'
import { SizeDataCategory } from '@/types/size'
import { useTranslations } from 'next-intl'
import { useProductDetailSafe } from '../../context/product-detail-context'
import { useProductDetailStore } from '../../hooks/use-product-detail-store'
import { ProductInfoSizeItem } from './product-info-size-item'

type Props = {
  sizeChart: string
  gender_type: string
  size_guide: SizeDataCategory
}

export const ProductInfoSizes: React.FC<Props> = ({
  sizeChart,
  gender_type,
  size_guide,
}) => {
  const { sizeSelected, setSizeSelected, sizeOptions, product } =
    useProductDetailSafe()
  const { isDisableSize } = useProductDetailStore()
  const t = useTranslations('title')
  if (
    !sizeOptions?.length ||
    (sizeOptions.length === 1 && sizeOptions[0] === '')
  ) {
    return null
  }

  return (
    <div>
      <div className='mb-2 flex items-baseline justify-between lg:py-0'>
        <span className='font-sans text-base leading-5 text-neutral-900 max-lg:hidden'>
          {t('size')}:{' '}
          <p className='inline text-neutral-600'> {sizeSelected}</p>
        </span>
        <InstructionSize
          sizeChart={sizeChart}
          gender_type={gender_type}
          size_guide={size_guide}
          productId={product.id}
          product={product}
        />
      </div>

      <ul className='flex flex-wrap gap-3 lg:gap-4 lg:gap-y-3'>
        {sizeOptions.map((sizeOption, index) => (
          <ProductInfoSizeItem
            key={index}
            isActive={sizeSelected === sizeOption}
            onClick={() =>
              !isDisableSize(sizeOption) && setSizeSelected(sizeOption)
            }
            title={sizeOption}
            isDisabled={isDisableSize(sizeOption)}
          />
        ))}
      </ul>
    </div>
  )
}
